import { defineStore } from "pinia";
import { SalesReport } from "../models/SalesReport";
import { ComponentsApi } from "../api/ComponentsApi";
import { useUserManagerStore } from "./userManagerStore";
import { Component } from "../user";

interface NewComponentState {
    newComponent: SalesReport
}

const defaultComponent = new SalesReport();

export const useNewComponentStore = defineStore('newComponentStore', {
    state: (): NewComponentState => ({
        newComponent: defaultComponent
    }),

    actions: {
        send: async function () {
            if (this.newComponent.id) {
                return await this.updateComponent();
            }

            const resp = await ComponentsApi.saveComponent(this.newComponent.toJSON())
                .catch((error) => error)

            if (resp) {
                const userManagerStore = useUserManagerStore();
                const component: Component = resp.data;
                userManagerStore.user?.components.push(component);
                return true;
            }

            return false;
        },

        updateComponent: async function () {
            const resp = await ComponentsApi.updateComponent(this.newComponent.toJSON())
                .catch((error) => error)

            if (resp) {
                const userManagerStore = useUserManagerStore();
                const component: Component = resp.data;
                const index = userManagerStore.user?.components.findIndex(c => c.id === component.id);
                if (index != null && index >= 0 && userManagerStore.user?.components[index]) {
                    userManagerStore.user.components[index] = component;
                }

                return true;
            }

            return false;
        },

        loadEditing: async function (componentId: string) {
            const userManagerStore = useUserManagerStore();
            const sr = new SalesReport();
            const component = userManagerStore.user?.components.find(c => c.id === componentId);

            if (!component) {
                throw new Error('Component not found');
            }

            sr.updateFromJson(component.config)
            sr.id = component.id;

            if (component.config.customStartDate) {
                sr.customStartDate = component.config.customStartDate;
            }
            if (component.config.customEndDate) {
                sr.customEndDate = component.config.customEndDate;
            }
            if (component.config.previousCustomStartDate) {
                sr.previousCustomStartDate = component.config.previousCustomStartDate;
            }
            if (component.config.previousCustomEndDate) {
                sr.previousCustomEndDate = component.config.previousCustomEndDate;
            }

            this.newComponent = sr;
        },

        reset: function () {
            this.newComponent = new SalesReport();
        }
    }
})